(function () {
  var CACHE_PREFIX = 'wom_review_summary_v1_';
  var CACHE_TTL = 10 * 60 * 1000;

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getConfig() {
    var cfg = (typeof window !== 'undefined' && window.vesselsWOMConfig) || {};
    return {
      apiBaseUrl: cfg.apiBaseUrl || 'https://api.thewordofmouth.in',
      companyId: cfg.companyId || 'sotrue',
      getHandle:
        cfg.getProductHandle ||
        function () {
          var match = window.location.pathname.match(/\/products\/([^/?]+)/);
          return match ? match[1] : null;
        }
    };
  }

  function buildApiUrl(handle) {
    var cfg = getConfig();
    return (
      cfg.apiBaseUrl +
      '/api/reviews/' +
      cfg.companyId +
      '/' +
      encodeURIComponent(handle) +
      '?offset=0&limit=5'
    );
  }

  function readCache(handle) {
    try {
      var raw = sessionStorage.getItem(CACHE_PREFIX + handle);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || Date.now() - parsed.ts > CACHE_TTL) return null;
      return parsed.data;
    } catch (e) {
      return null;
    }
  }

  function writeCache(handle, data) {
    try {
      sessionStorage.setItem(CACHE_PREFIX + handle, JSON.stringify({ ts: Date.now(), data: data }));
    } catch (e) {}
  }

  function normalizeSummary(highlights) {
    if (!highlights) return '';
    var summary = highlights.summary || highlights.text || '';
    if (Array.isArray(summary)) {
      return summary
        .map(function (item) {
          return String(item || '').trim();
        })
        .filter(Boolean)
        .join(' ');
    }
    return String(summary || '').trim();
  }

  function normalizeKeywords(highlights) {
    if (!highlights) return [];
    var keywords = highlights.keywords || highlights.key_points || [];
    if (!Array.isArray(keywords)) {
      keywords = keywords ? [keywords] : [];
    }
    return keywords
      .map(function (item) {
        if (typeof item === 'string') return item.trim();
        if (item && typeof item === 'object') {
          return String(item.keyword || item.label || item.name || '').trim();
        }
        return '';
      })
      .filter(Boolean);
  }

  function keywordCount(keyword, mentions, index, totalReviews) {
    if (mentions && mentions[index]) {
      var mention = String(mentions[index]);
      var pctMatch = mention.match(/^(\d+)%/);
      if (pctMatch && totalReviews) {
        return Math.max(1, Math.round((totalReviews * parseInt(pctMatch[1], 10)) / 100));
      }
      if (pctMatch) {
        return parseInt(pctMatch[1], 10);
      }
    }

    var lower = String(keyword).toLowerCase();
    if (Array.isArray(mentions)) {
      for (var i = 0; i < mentions.length; i++) {
        var text = String(mentions[i] || '').toLowerCase();
        if (text.indexOf(lower) !== -1) {
          var match = String(mentions[i]).match(/^(\d+)%/);
          if (match && totalReviews) {
            return Math.max(1, Math.round((totalReviews * parseInt(match[1], 10)) / 100));
          }
          if (match) return parseInt(match[1], 10);
        }
      }
    }

    return null;
  }

  function renderKeywords(container, keywords, mentions, totalReviews) {
    container.innerHTML = '';
    if (!keywords.length) {
      container.hidden = true;
      return;
    }

    container.hidden = false;
    keywords.forEach(function (keyword, index) {
      var pill = document.createElement('span');
      pill.className = 'wom-review-summary__keyword';

      var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      icon.setAttribute('class', 'wom-review-summary__keyword-icon');
      icon.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      icon.setAttribute('width', '16');
      icon.setAttribute('height', '16');
      icon.setAttribute('viewBox', '0 0 24 24');
      icon.setAttribute('fill', 'none');
      icon.setAttribute('stroke', 'currentColor');
      icon.setAttribute('stroke-width', '2.5');
      icon.setAttribute('stroke-linecap', 'round');
      icon.setAttribute('stroke-linejoin', 'round');
      icon.setAttribute('aria-hidden', 'true');

      var line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      line.setAttribute('x1', '7');
      line.setAttribute('y1', '17');
      line.setAttribute('x2', '17');
      line.setAttribute('y2', '7');
      icon.appendChild(line);

      var polyline = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
      polyline.setAttribute('points', '7 7 17 7 17 17');
      icon.appendChild(polyline);

      var count = keywordCount(keyword, mentions, index, totalReviews);
      var label = document.createElement('span');
      label.className = 'wom-review-summary__keyword-text';

      var keywordLabel = document.createElement('span');
      keywordLabel.className = 'wom-review-summary__keyword-label';
      keywordLabel.textContent = keyword;
      label.appendChild(keywordLabel);

      if (count) {
        var countLabel = document.createElement('span');
        countLabel.className = 'wom-review-summary__keyword-count';
        countLabel.textContent = ' (' + count + ')';
        label.appendChild(countLabel);
      }

      pill.appendChild(icon);
      pill.appendChild(label);
      container.appendChild(pill);
    });
  }

  function applyData(root, data) {
    var highlights = data.highlights || data.ai_summary || null;
    var summaryText = normalizeSummary(highlights);
    var keywords = normalizeKeywords(highlights);
    var totalReviews = Number(data.total_reviews) || 0;

    if (!summaryText && !keywords.length) {
      root.classList.remove('is-visible');
      root.hidden = true;
      return;
    }

    if (totalReviews <= 0 && !summaryText && !keywords.length) {
      root.classList.remove('is-visible');
      root.hidden = true;
      return;
    }

    var bodyEl = root.querySelector('[data-wom-review-summary-body]');
    var keywordsEl = root.querySelector('[data-wom-review-summary-keywords]');

    if (bodyEl) {
      bodyEl.textContent = summaryText;
      bodyEl.hidden = !summaryText;
    }

    if (keywordsEl) {
      renderKeywords(keywordsEl, keywords, highlights && highlights.customer_mentions, totalReviews);
    }

    root.hidden = false;
    root.classList.add('is-visible');
  }

  function fetchAndRender(root) {
    var handle = root.getAttribute('data-product-handle');
    if (!handle) return;

    var cached = readCache(handle);
    if (cached) {
      applyData(root, cached);
    }

    fetch(buildApiUrl(handle), { credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        writeCache(handle, data);
        applyData(root, data);
      })
      .catch(function () {
        if (!cached) {
          root.classList.remove('is-visible');
          root.hidden = true;
        }
      });
  }

  function initAll() {
    document.querySelectorAll('[data-wom-review-summary]').forEach(fetchAndRender);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
